// extracted by mini-css-extract-plugin
export default {"recaptcha-link":"CaptchaDisclosure-module__recaptcha-link__PvZj_"};